import { Recorder } from "@/components/app/Recorder";
import { ConsentBox, MeetingForm, useSubmitMeeting } from "@/components/app/MeetingForm";
import { useRecorder } from "@/context/RecorderContext";
import { PageHeader, Card } from "@/components/app/StatusBadge";
import { FreeLimitBanner } from "@/components/billing/FreeLimitBanner";
import { InstallAppButton } from "@/components/app/InstallApp";
import { useApp } from "@/lib/i18n";

export default function RecordPage() {
  const { L } = useApp();
  const [meta, set] = useRecorder().form;
  const { submit, busy, bar } = useSubmitMeeting();
  return (
    <div className="mx-auto max-w-5xl px-4 py-8 sm:px-8" data-testid="record-page">
      <PageHeader title={L("Rakam", "Record")} desc={L("Rakam terus dari pelayar. Rakaman disimpan sementara di peranti anda sehingga berjaya dihantar.", "Record directly in the browser. Audio is kept on your device until it is successfully sent.")} />
      <FreeLimitBanner />
      <div className="mt-4 flex flex-wrap items-center gap-3 empty:hidden">
        <InstallAppButton testId="record-install-btn" />
      </div>
      <div className="mt-6"><Recorder onSubmit={(b) => submit(b, b.type.includes("mp4") ? "rakaman.m4a" : "rakaman.webm", meta, "record")} busy={busy} consent={<ConsentBox checked={meta.consent} onChange={(v) => set("consent", v)} className="mt-5" />} /></div>
      {bar}
      <Card className="mt-6 p-6"><h2 className="mb-4 font-semibold">{L("Butiran mesyuarat", "Meeting details")}</h2><MeetingForm meta={meta} set={set} hideConsent /></Card>
    </div>
  );
}
